@if (sanitizedUrl()) {
  <iframe
    #frame
    [src]="sanitizedUrl()"
    title="Dashboard V2"
    style="flex: 1; border: unset"
  ></iframe>
}
